import React from "react";

function MoreIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
    >
      <g id="More_Icon" data-name="More Icon" transform="translate(-325 -688)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="18.5"
          cy="18.5"
          r="18.5"
          transform="translate(325 688)"
          opacity="0.7"
        />
        <g
          id="_3_Blue_Dot"
          data-name="3 Blue Dot"
          transform="translate(353.032 704.187) rotate(90)"
        >
          <g id="Group_124" data-name="Group 124">
            <path
              id="Path_117"
              data-name="Path 117"
              d="M4.008.688a2.348,2.348,0,1,1-3.32,0,2.348,2.348,0,0,1,3.32,0"
              fill="#fff"
            />
            <path
              id="Path_118"
              data-name="Path 118"
              d="M4.008.688a2.348,2.348,0,1,1-3.32,0,2.347,2.347,0,0,1,3.32,0"
              transform="translate(0 7.043)"
              fill="#fff"
            />
            <path
              id="Path_119"
              data-name="Path 119"
              d="M4.008.688a2.348,2.348,0,1,1-3.32,0,2.347,2.347,0,0,1,3.32,0"
              transform="translate(0 14.087)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default MoreIcon;
